/* TODO: Rewrite not to use jQuery */
jQuery = window.jQuery;
jQuery( document ).ready(function() {
  $("#getzipzonetimefrm").submit(function(){
    if( $(this).find("input[type=text], input[type=number]").val().length != 5){
      $("#getzipzonetimefrm .error").html("Zipcode should contain exactly 5 chars!").show();
      return false;
    }
    var zipcodePattern = /^[0-9]+$/
    if(zipcodePattern.test( $(this).find("input[type=text], input[type=number]").val() ) == false){
      $("#getzipzonetimefrm .error").html("Zipcode should contain only digits!").show();
      return false;
    }

    $("#getzipzonetimefrm .error").hide();
    $(this).addClass("loading");

    $.ajax({
      url: "https://apps.edenbrothers.com/getzipzone.php",
      method: "get",
      data: "zipcode=" + $(this).find("input[type=text], input[type=number]").val(),
      success: function(response){
        $("#getzipzonetimefrm").removeClass("loading");
        var result = $.parseJSON(response)
        if( result.error ){
          $("#getzipzonetimefrm .error").html( result.error ).show();
        }else{
          let zone_name = 'zone_' + result.zipzone.replace('a', '').replace('b', '');
          let zone_times = JSON.parse(document.getElementById('getzipzonetimes').textContent);

          if(zone_times.hasOwnProperty(zone_name)){
            var zone_time = zone_times[zone_name];
          }
          else{
            var zone_time = 'There was an issue loading this ship time. Please try again.';
          }

          $("#getzipzonetimefrm .form").hide();
          $("#getzipzonetimefrm .result").show();
          $("#getzipzonetimefrm .zipzone").html( result.zipzone )

          let zipzonetimetext  = $("#getzipzonetimefrm .zipzonetime").attr( 'data-text' );
          $("#getzipzonetimefrm .zipzonetime").html( zipzonetimetext.replace('{{ zone }}',result.zipzone).replace('{{ ship_time }}',zone_time) );
        }
      }
    })
    return false;
  });
  
  $("#getzipzonetimefrm .result a").click(function(){
    $("#getzipzonetimefrm .form").show();
    $("#getzipzonetimefrm .result").hide();
    $("#getzipzonetimefrm-code").val("").focus();
    return false;
  });
});